import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import companyInfoBg from '../../assets/companyInfoBg.png';
import companyInfoBgMobile from '../../assets/companyInfoBgMobile.png';
import styles from './CompanyInfo.module.scss';
import { isDesktop } from 'react-device-detect';
function CompanyInfo() {
  return (
    <div>
      <Header />
      <div className={styles.contentWrap}>
        <img
          src={isDesktop ? companyInfoBg : companyInfoBgMobile}
          alt="Company Info"
          className={styles.bgImage}
        />
      </div>
      <Footer />
    </div>
  );
}

export default CompanyInfo;
